import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

function PurchaseOrderIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 50 50" {...props}>
      <path d="M 4 0 L 4 1 L 4 49 L 4 50 L 5 50 L 45 50 L 46 50 L 46 49 L 46 1 L 46 0 L 45 0 L 5 0 L 4 0 z M 6 2 L 44 2 L 44 48 L 6 48 L 6 2 z M 13 11 L 13 13 L 37 13 L 37 11 L 13 11 z M 13 25 L 13 27 L 17 27 L 17 25 L 13 25 z M 20 25 L 20 27 L 37 27 L 37 25 L 20 25 z M 13 31 L 13 33 L 17 33 L 17 31 L 13 31 z M 20 31 L 20 33 L 37 33 L 37 31 L 20 31 z M 13 37 L 13 39 L 17 39 L 17 37 L 13 37 z M 20 37 L 20 39 L 37 39 L 37 37 L 20 37 z" />
    </SvgIcon>
  );
}

export default PurchaseOrderIcon;
